module.exports = __webpack_public_path__ + "static/img/memory2.8637c37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memory2.jpg
// module id = /INq
// module chunks = 1